export default __webpack_public_path__ + "static/media/dinner5.a1456d0d.png";